import { ResourceOptions } from 'react-admin';
import { Resources } from '../../resource';

export { default as list } from './List';
export const name = Resources.whitelistEventParticipants;
export const options: ResourceOptions = {
  label: 'whitelist.eventParticipants.title',
};
